import type { Epic } from '../../index.ts'
import type { Action } from '@reduxjs/toolkit'
import { EMPTY, filter, mergeMap, tap } from 'rxjs'
import { visualizationSlice } from '../../Slice/Visualization/VisualizationSlice.ts'
import { clearAllCubeTables } from '../../../Repository/Visualization/CubeTableRegistry.ts'
import { clearAllSelectorCaches } from '../../../View/Component/ConfigurableVisualization/Sinks/Selector/SelectorCache.ts'

/**
 * Releases the process-local cube caches when the workspace is reset.
 *
 * `visualization.reset` wipes the slice back to `initialState`, but the decoded-table registry and
 * the memoised selector caches (`CubeContext`, `SelectFilteredCube`, every transformer) live
 * OUTSIDE Redux and would otherwise accumulate across in-session workspace switches — a new
 * selector instance per source and per zoomed path, never collected. The loader dispatches `reset`
 * on (re-)entry (`VizLoaderPage`), so this is the natural place to drop them; they rebuild lazily.
 *
 * NOT cleared here: the IndexedDB byte cache (`CubeCache`) — it is deliberately persistent for
 * cross-reload ETag revalidation, and the decoded `WeakMap` in `CubeFiltering` is GC'd implicitly
 * once its `Table` leaves the registry.
 */
export const cacheResetEpic: Epic = (action$) =>
  action$.pipe(
    filter((a: Action) => visualizationSlice.actions.reset.match(a)),
    tap(() => {
      clearAllSelectorCaches()
      clearAllCubeTables()
    }),
    mergeMap(() => EMPTY) // side-effect only — emits no actions
  )
